export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5184.5edf4afc.jpg";